var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"dark":"","app":""}},[_c('div',{staticClass:"footer"},[_vm._v(" Copyright 2021 Randomer ")])])}
var staticRenderFns = []

export { render, staticRenderFns }